import { render, staticRenderFns } from "./SacMemberStart.vue?vue&type=template&id=6b205b22"
import script from "./SacMemberStart.vue?vue&type=script&lang=js"
export * from "./SacMemberStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports